/* eslint-disable import/named */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { mergeStyleSets, Stack, Text } from '@fluentui/react';
import { isNil } from 'lodash-es';
import { AppContainer, CheckoutWizardReadyStep, ComponentStatus, StatusChangeSource, CheckoutWizardActionType, isComponentBusy, StatusChangeDataType, CheckoutWizardProfile, CheckoutWizardAddProfile, CheckoutWizardPayment, CheckoutWizardBillingProfile, UserType } from '@microsoft-commerce/purchase-blends-component-library';
import { getEnhancer } from '@appsource/utils/purchaseBlendsEnhancer';
import { getConsentState, getPurchaseBlendsMessageOverrides, isContactInfoHiddenInDisclaimer, pbOther } from '@shared/utils/checkoutUtils';
import AddEditView from '../addEditView';
import { Constants } from '@shared/utils/constants';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { getWindow } from '@shared/services/window';
import { DisclaimerComponent } from '../disclaimerComponent';
import { FreeTrialInfoText } from '../freeTrialInfoText';
import { logger } from '@src/logger';
import classNames from 'classnames';
import { AppSourceAddEditSteps, getPurchaseBlendsEnv, getPurchaseBlendsFlags, getAppContainerProps, getUserData, getUserType, isTestUser } from '@appsource/utils/checkoutSettings';
import { OrderLoading, BusyLoader } from '@appsource/components';
import { saveLocalStorageItem } from '@shared/utils/browserStorageUtils';
import { CartActionTypes } from '@microsoft-commerce/purchase-blends-component-library/dist/lib/store/cart/actions';
import { HttpModule } from '@shared/services/http/httpProtocol';
import { CheckoutWizardStepName } from '@microsoft-commerce/purchase-blends-component-library/dist/lib/components/wizard/checkout/types';
import { isOneTimePaymentOffer } from '@shared/utils/onetimepaymentoffers';
const pbTelemetry = Constants.Telemetry.PurchaseBlendsTelemetry;
// Has to be outside mergeStyleSets as these are used for inline-style to override PB component specificity level
const contentStyles = mergeStyleSets({
    legalTermsContainer: {
        display: 'none',
        [`@media (max-width: 1720px)`]: {
            display: 'unset'
        }
    },
    busyLoaderContainer: {
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        width: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: '100',
        top: '0',
        left: '0'
    },
    appContainerContainer: {
        margin: '8px 0'
    },
    azureSubscriptionPurchaseContainer: {
        maxWidth: '220px',
        backgroundColor: 'rgb(243, 242, 241)',
        wordBreak: 'keep-all',
        padding: '8px',
        zIndex: 2
    },
    purchaseBlendsWizardClass: {
        minHeight: '780px',
        '@media (maxWidth: 800px)': {
            minHeight: '1000px',
            width: 'auto',
            paddingTop: '50px'
        }
    }
});
export const PurchaseBlendsCheckout = ({ setPi, setActiveStep, setPurchaseReceipt, setSoldToAddress, disableBackButton, sendLeadInfo, app, app: { entityId }, context, users, users: { roleDefinitions, accessToken, tid }, config: { featureFlags, locale, siteEnvironment, flightCodes }, checkout: { items, purchaseAttempt, currentStep }, paymentStepStartedTime, billingCountry, adminFlow, isBagOffer, isProfessionalService, checkoutId })=>{
    var _cartItem_additionalData, _getWindow_location, _getWindow, _app_detailInformation;
    const location = useLocation();
    const [checkoutWizardStep, setCheckoutWizardStep] = useState(StatusChangeSource.ReadyToPurchase);
    const [isBusy, setIsBusy] = useState(true);
    const [foundServerError, setFoundServerError] = useState(false);
    const [placeOrderSucceeded, setPlaceOrderSucceeded] = useState(false);
    const [clientErrorType, setClientErrorType] = useState(null);
    const [placeOrderLoading, setPlaceOrderLoading] = useState(false);
    const markStart = useRef(null);
    const componentStatuses = useRef([]);
    const checkoutLoaded = useRef(false);
    const loggedCheckoutLoaded = useRef(false);
    const lastStep = useRef(checkoutWizardStep);
    const timerRef = useRef(null);
    const titleRef = useRef(null);
    const completePurchaseSucceeded = useRef(false);
    const loadedCart = useRef(null);
    const telemetryStatusListenerDelay = 500;
    const { bigId, skuId, termId, termDuration, recurringBilling, quantity, id: planId, product, hasFreeTrial, isQuantifiable } = items[0];
    const isOneTimePayment = isOneTimePaymentOffer(entityId);
    const userData = getUserData({
        locale,
        market: billingCountry,
        accessToken,
        adminFlow
    });
    const userType = getUserType(roleDefinitions);
    const { purchaseBlendsComponentStrings, companyName, email, cartItem } = getAppContainerProps({
        product,
        planId,
        termId,
        termDuration,
        users,
        locale,
        bigId,
        skuId,
        quantity,
        recurringBilling,
        isBagOffer,
        isOneTimePayment,
        isProfessionalService
    });
    const multiYearTerm = ((_cartItem_additionalData = cartItem.additionalData) === null || _cartItem_additionalData === void 0 ? void 0 : _cartItem_additionalData.billingCycle) === pbOther;
    const logLoadedTelemetry = ()=>{
        var _lineItems__additionalData, _lineItems_, _term_price;
        const { appTitle: planTitle } = items[0];
        loggedCheckoutLoaded.current = true;
        const { hasFreeTrial, product } = items[0];
        const { totalPrice, subTotal, totalTax, lineItems, additionalData } = loadedCart.current;
        const { postTrialPricing } = additionalData || {};
        const { unitPrice, totalPrice: lineItemTotalPrice, quantity } = (lineItems === null || lineItems === void 0 ? void 0 : lineItems[0]) || {};
        const { renewalUnitPrice, renewalTotalPrice } = (lineItems === null || lineItems === void 0 ? void 0 : (_lineItems_ = lineItems[0]) === null || _lineItems_ === void 0 ? void 0 : (_lineItems__additionalData = _lineItems_.additionalData) === null || _lineItems__additionalData === void 0 ? void 0 : _lineItems__additionalData.renewalData) || {};
        const term = product === null || product === void 0 ? void 0 : product.getTermByTermId({
            planId,
            termId
        });
        const payload = {
            page: location.pathname,
            action: Constants.Telemetry.Action.Checkout,
            actionModifier: Constants.Telemetry.ActionModifier.PaymentLoaded,
            appName: entityId,
            details: JSON.stringify({
                duration: Date.now() - paymentStepStartedTime,
                userType,
                adminFlow,
                isBagOffer,
                multiYearTerm,
                totalPrice,
                subTotal,
                totalTax,
                renewalUnitPrice,
                renewalTotalPrice,
                postTrialPricing,
                unitPrice,
                lineItemTotalPrice,
                targetUnitPrice: term === null || term === void 0 ? void 0 : (_term_price = term.price) === null || _term_price === void 0 ? void 0 : _term_price.msrp,
                hasFreeTrial,
                isProfessionalService,
                planTitle,
                cartItem: _object_spread_props(_object_spread({}, cartItem), {
                    quantity
                }),
                checkoutId
            })
        };
        SpzaInstrumentService.getProvider().probe('logAndFlushTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName,
            page: payload.page
        });
    };
    useEffect(()=>{
        loggedCheckoutLoaded.current = false;
        if (checkoutLoaded.current && paymentStepStartedTime) {
            logLoadedTelemetry();
        }
    }, [
        paymentStepStartedTime
    ]);
    useEffect(()=>{
        return ()=>clearTimeout(timerRef.current);
    }, []);
    const isStatusReadyToPaymentLoaded = (statusChangeData)=>{
        var _statusChangeData_context;
        return (statusChangeData === null || statusChangeData === void 0 ? void 0 : statusChangeData.status) === ComponentStatus.Loaded && (statusChangeData === null || statusChangeData === void 0 ? void 0 : (_statusChangeData_context = statusChangeData.context) === null || _statusChangeData_context === void 0 ? void 0 : _statusChangeData_context.source) === CheckoutWizardStepName.ReadyToPurchase;
    };
    const emitStatusTelemetry = (statusChangeData)=>{
        if (statusChangeData.context) {
            componentStatuses.current = [
                ...componentStatuses.current,
                statusChangeData
            ];
        }
        if (!checkoutLoaded.current && isStatusReadyToPaymentLoaded(statusChangeData)) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(()=>{
                if (!checkoutLoaded.current && componentStatuses.current.length && isStatusReadyToPaymentLoaded(componentStatuses.current[componentStatuses.current.length - 1])) {
                    checkoutLoaded.current = true;
                    if (paymentStepStartedTime && !loggedCheckoutLoaded.current) {
                        logLoadedTelemetry();
                    }
                }
            }, telemetryStatusListenerDelay);
        }
    };
    const updateCheckoutWizardStep = (source)=>{
        setCheckoutWizardStep(source);
        const payload = {
            page: location.pathname,
            action: Constants.Telemetry.Action.Checkout,
            actionModifier: Constants.Telemetry.ActionModifier.ChangeCheckoutView,
            appName: entityId,
            details: `Current source: ${source}. CheckoutId: ${checkoutId}`
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName,
            page: payload.page
        });
    };
    const handleDataReadyStep = (context)=>{
        if (context.source === StatusChangeSource.ReadyToPurchase && context.dataType === StatusChangeDataType.PreviewReceipt && placeOrderSucceeded && // only if passed through Success after place order
        !completePurchaseSucceeded.current) {
            completePurchaseSucceeded.current = true;
            setPurchaseReceipt(context.data);
            setPlaceOrderLoading(false);
            // Finish the purchase and move to order confirmation screen
            setActiveStep(currentStep + 1);
            saveLocalStorageItem(Constants.PurchaseBlends.AlreadyPurchasedKey, Constants.PurchaseBlends.AlreadyPurchased);
            const payload = {
                page: location.pathname,
                action: Constants.Telemetry.Action.Checkout,
                actionModifier: Constants.Telemetry.ActionModifier.CompletePurchase,
                appName: entityId,
                details: JSON.stringify({
                    duration: markStart.current ? Date.now() - markStart.current : null,
                    paymentInfo: context.data.paymentInfo,
                    userType,
                    adminFlow,
                    receipt: context.data,
                    cartItem,
                    isBagOffer,
                    multiYearTerm,
                    isProfessionalService,
                    checkoutId
                })
            };
            SpzaInstrumentService.getProvider().probe('logAndFlushTelemetryInfo', payload);
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier,
                appName: payload.appName,
                page: payload.page
            });
        }
    };
    const handleSuccessStatus = (context)=>{
        if (context.source === StatusChangeSource.ReadyToPurchase) {
            setPlaceOrderSucceeded(true);
        } else {
            updateCheckoutWizardStep(StatusChangeSource.ReadyToPurchase);
        }
    };
    const handleEditingStatus = (context)=>{
        if (context.destination === CheckoutWizardActionType.AddBillingProfile) {
            updateCheckoutWizardStep(StatusChangeSource.AddBillingProfile);
            lastStep.current = context.source;
        }
        if (context.destination === CheckoutWizardActionType.EditBillingProfile) {
            updateCheckoutWizardStep(StatusChangeSource.EditBillingProfile);
            lastStep.current = context.source;
        }
        if (context.destination === CheckoutWizardActionType.AddPayment) {
            updateCheckoutWizardStep(StatusChangeSource.AddPayment);
            lastStep.current = context.source;
        }
        if (context.destination === CheckoutWizardActionType.EditProfile) {
            updateCheckoutWizardStep(StatusChangeSource.EditProfile);
            lastStep.current = context.source;
        }
        if (context.destination === CheckoutWizardActionType.AddProfile) {
            updateCheckoutWizardStep(StatusChangeSource.AddProfile);
            lastStep.current = context.source;
        }
    };
    const stepListener = (status, context)=>{
        const { type: userFlow } = userData;
        let checkoutLoading = isBusy;
        if (context.isCheckoutLoadingEvent) {
            checkoutLoading = isComponentBusy(status);
            setIsBusy(checkoutLoading);
            checkoutLoaded.current = checkoutLoading ? false : checkoutLoaded.current;
        }
        switch(status){
            case ComponentStatus.Editing:
                handleEditingStatus(context);
                break;
            case ComponentStatus.Cancelled:
                updateCheckoutWizardStep([
                    StatusChangeSource.EditProfile,
                    StatusChangeSource.AddBillingProfile
                ].includes(context.source) ? StatusChangeSource.ReadyToPurchase : lastStep.current);
                break;
            case ComponentStatus.Success:
                handleSuccessStatus(context);
                break;
            case ComponentStatus.DataReady:
                handleDataReadyStep(context);
                break;
            case ComponentStatus.Saving:
                if (context.source === StatusChangeSource.AddPayment && userFlow === UserType.myOrg) {
                    updateCheckoutWizardStep(StatusChangeSource.AddBillingProfile);
                }
                break;
            case ComponentStatus.TerminalFailure:
            case ComponentStatus.TransientFailure:
                {
                    var _context_data;
                    if (context === null || context === void 0 ? void 0 : (_context_data = context.data) === null || _context_data === void 0 ? void 0 : _context_data.error) {
                        const payload = {
                            page: location.pathname,
                            action: Constants.Telemetry.Action.Purchase,
                            actionModifier: Constants.Telemetry.ActionModifier.Error,
                            appName: entityId,
                            details: `${pbTelemetry.Errors.PBErrorPrefix}${status}`
                        };
                        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
                        logger.error(`${pbTelemetry.Errors.PBErrorPrefix}${status}`, {
                            action: Constants.Telemetry.Action.Purchase,
                            actionModifier: Constants.Telemetry.ActionModifier.Error,
                            error: context.data.error,
                            page: pbTelemetry.PageName
                        });
                    }
                    break;
                }
            case ComponentStatus.NavigateNext:
                {
                    const payload = {
                        page: location.pathname,
                        action: Constants.Telemetry.Action.Purchase,
                        actionModifier: Constants.Telemetry.ActionModifier.InProgress,
                        appName: entityId,
                        details: `${pbTelemetry.FinishedLoading}`
                    };
                    SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
                    logger.info(`${pbTelemetry.FinishedLoading}`, {
                        action: Constants.Telemetry.Action.Purchase,
                        actionModifier: Constants.Telemetry.ActionModifier.InProgress,
                        appName: payload.appName,
                        page: pbTelemetry.PageName
                    });
                    break;
                }
            default:
                break;
        }
        emitStatusTelemetry({
            status,
            context,
            isComponentBusy: checkoutLoading
        });
    };
    const dismissAddEditHandler = ()=>{
        updateCheckoutWizardStep(StatusChangeSource.ReadyToPurchase);
        const payload = {
            page: location.pathname,
            action: Constants.Telemetry.Action.Close,
            actionModifier: Constants.Telemetry.ActionModifier.Purchase,
            appName: entityId,
            details: `${pbTelemetry.DismissedPrefix}${lastStep}`
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName,
            page: payload.page
        });
    };
    const logError = (error, state)=>{
        var _state_cart_errors__config, _state_cart_errors_, _state_cart_errors, _state_cart;
        const cv = state === null || state === void 0 ? void 0 : (_state_cart = state.cart) === null || _state_cart === void 0 ? void 0 : (_state_cart_errors = _state_cart.errors) === null || _state_cart_errors === void 0 ? void 0 : (_state_cart_errors_ = _state_cart_errors[0]) === null || _state_cart_errors_ === void 0 ? void 0 : (_state_cart_errors__config = _state_cart_errors_.config) === null || _state_cart_errors__config === void 0 ? void 0 : _state_cart_errors__config.headers[Constants.Headers.CV];
        const payload = {
            page: location.pathname,
            action: Constants.Telemetry.Action.Checkout,
            actionModifier: Constants.Telemetry.ActionModifier.Error,
            appName: entityId,
            details: JSON.stringify({
                error,
                cv,
                cartItem,
                userType,
                adminFlow,
                isBagOffer,
                multiYearTerm,
                isProfessionalService,
                checkoutId
            })
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.error(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName,
            page: payload.page
        });
    };
    const logPlaceOrderTelemetry = ()=>{
        const payload = {
            appName: entityId,
            page: location.pathname,
            action: Constants.Telemetry.Action.Checkout,
            actionModifier: Constants.Telemetry.ActionModifier.PlaceOrderClicked,
            details: JSON.stringify({
                userType,
                cartItem,
                adminFlow,
                isBagOffer,
                multiYearTerm,
                isProfessionalService,
                checkoutId
            })
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            appName: entityId,
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page
        });
    };
    const logProcessLeadInfoTelemetry = (actionModifier, details)=>{
        const payload = {
            page: location === null || location === void 0 ? void 0 : location.pathname,
            action: Constants.Telemetry.Action.ProcessLeadInfo,
            actionModifier,
            details: JSON.stringify(details)
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page
        });
    };
    const shouldProcessLeadInfo = (app)=>{
        if (!app || app.privateApp === true) {
            logProcessLeadInfoTelemetry(Constants.Telemetry.ActionModifier.Skip, {
                reason: Constants.Telemetry.LeadsDropReason.AppNotAvailableOrPrivate,
                uniqueProductId: app === null || app === void 0 ? void 0 : app.entityId
            });
            return false;
        }
        if (flightCodes) {
            logProcessLeadInfoTelemetry(Constants.Telemetry.ActionModifier.Skip, {
                reason: Constants.Telemetry.LeadsDropReason.PreviewOffer,
                uniqueProductId: app === null || app === void 0 ? void 0 : app.entityId
            });
            return false;
        }
        return true;
    };
    const processLeadInfo = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function*() {
            try {
                logProcessLeadInfoTelemetry(Constants.Telemetry.ActionModifier.Start, {
                    data: 'Processing a lead in transact flow.'
                });
                if (shouldProcessLeadInfo(app)) {
                    yield sendLeadInfo({
                        item: app,
                        ctaType: Constants.CTAType.Purchase,
                        planId
                    });
                    logProcessLeadInfoTelemetry(Constants.Telemetry.ActionModifier.End, {});
                }
            } catch (error) {
                logProcessLeadInfoTelemetry(Constants.Telemetry.ActionModifier.Error, {
                    error
                });
            }
        });
        return function processLeadInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    const getStateChangeListener = (state)=>{
        var _state_cart_content_lineItems_, _state_cart_content_lineItems, _state_cart_content, _state_cart;
        if (!state) {
            return; // we do not care about the initial undefined state
        }
        if (state.cart.loadingActionType === CartActionTypes.PlaceOrder && !markStart.current) {
            var _this;
            setPlaceOrderLoading(true);
            disableBackButton(true);
            titleRef.current.scrollIntoView();
            markStart.current = Date.now();
            logPlaceOrderTelemetry();
            const { soldTo, soldToV2 } = state.cart.content;
            const companyName = (_this = soldTo || soldToV2) === null || _this === void 0 ? void 0 : _this.companyName;
            const soldToAddress = (soldTo === null || soldTo === void 0 ? void 0 : soldTo.defaultAddress) || (soldToV2 === null || soldToV2 === void 0 ? void 0 : soldToV2.address);
            if (soldToAddress) {
                setSoldToAddress(_object_spread({
                    companyName
                }, soldToAddress));
            }
            processLeadInfo();
        }
        const cartError = (_state_cart = state.cart) === null || _state_cart === void 0 ? void 0 : (_state_cart_content = _state_cart.content) === null || _state_cart_content === void 0 ? void 0 : (_state_cart_content_lineItems = _state_cart_content.lineItems) === null || _state_cart_content_lineItems === void 0 ? void 0 : (_state_cart_content_lineItems_ = _state_cart_content_lineItems[0]) === null || _state_cart_content_lineItems_ === void 0 ? void 0 : _state_cart_content_lineItems_.error;
        const hasErrorMessages = state.messageCenter.messages.length > 0;
        if ((cartError || hasErrorMessages) && placeOrderLoading) {
            setPlaceOrderLoading(false);
        }
        if (cartError && !foundServerError) {
            var _state_cart_content_lineItems_1, _state_cart_content_lineItems1, _state_cart_content1, _state_cart1;
            setFoundServerError(true);
            const serverError = state === null || state === void 0 ? void 0 : (_state_cart1 = state.cart) === null || _state_cart1 === void 0 ? void 0 : (_state_cart_content1 = _state_cart1.content) === null || _state_cart_content1 === void 0 ? void 0 : (_state_cart_content_lineItems1 = _state_cart_content1.lineItems) === null || _state_cart_content_lineItems1 === void 0 ? void 0 : (_state_cart_content_lineItems_1 = _state_cart_content_lineItems1[0]) === null || _state_cart_content_lineItems_1 === void 0 ? void 0 : _state_cart_content_lineItems_1.error;
            logError(JSON.stringify(serverError), state);
            markStart.current = null;
        }
        if (hasErrorMessages && !clientErrorType) {
            var _state_messageCenter_messages;
            setClientErrorType(state.messageCenter.messages[0].payload.type);
            const errorIds = JSON.stringify((_state_messageCenter_messages = state.messageCenter.messages) === null || _state_messageCenter_messages === void 0 ? void 0 : _state_messageCenter_messages[0].payload);
            logError(errorIds, state);
            markStart.current = null;
        }
        loadedCart.current = state.cart.content;
        setPi(state.payments.paymentInstruments.content);
    };
    const isAddEditVisible = AppSourceAddEditSteps.indexOf(checkoutWizardStep) > -1;
    const testUser = isTestUser({
        tenantId: tid
    });
    const appContainerProps = {
        ensureCartTrigger: purchaseAttempt || 0,
        stateChangeListener: getStateChangeListener,
        requestEnhancer: getEnhancer({
            testUser,
            siteEnvironment,
            retrieveTokens: ()=>HttpModule.getAccessToken()
        }),
        validation: {
            tokenRequired: false
        },
        env: getPurchaseBlendsEnv((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.hostname),
        ensureCartWithInitData: true,
        applicationName: Constants.appSource,
        enableGreenId: true,
        messages: _object_spread({}, purchaseBlendsComponentStrings, getPurchaseBlendsMessageOverrides(context, isOneTimePayment, isProfessionalService)),
        user: userData,
        paymentSettings: {
            prefillData: {
                companyName,
                email
            }
        },
        cartInit: {
            items: [
                cartItem
            ]
        },
        flags: getPurchaseBlendsFlags({
            testUser,
            siteEnvironment,
            countryCode: billingCountry,
            isQuantifiable
        })
    };
    const paymentTitleClass = classNames({
        'ms-fontWeight-semibold': true,
        'ml-8': true
    });
    const readyToPurchase = bigId && skuId && termId && !isNil(recurringBilling);
    return /*#__PURE__*/ _jsx(Stack, {
        className: contentStyles.purchaseBlendsWizardClass,
        children: !readyToPurchase ? /*#__PURE__*/ _jsx("div", {
            className: contentStyles.busyLoaderContainer,
            children: /*#__PURE__*/ _jsx(BusyLoader, {
                context: context
            })
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: 'new-checkout-step-header',
                    ref: titleRef,
                    children: /*#__PURE__*/ _jsx(Text, {
                        className: paymentTitleClass,
                        children: context.loc('Checkout_Step_Payment', 'Payment')
                    })
                }),
                /*#__PURE__*/ _jsx(Stack, {
                    className: contentStyles.appContainerContainer,
                    children: /*#__PURE__*/ _jsx(AppContainer, _object_spread_props(_object_spread({}, appContainerProps), {
                        flags: _object_spread_props(_object_spread({}, appContainerProps.flags), {
                            EnableResetStore: true
                        })
                    }))
                }),
                (placeOrderLoading || isBusy) && /*#__PURE__*/ _jsx("div", {
                    className: contentStyles.busyLoaderContainer,
                    children: placeOrderLoading ? /*#__PURE__*/ _jsx(OrderLoading, {
                        context: context
                    }) : /*#__PURE__*/ _jsx(BusyLoader, {
                        context: context
                    })
                }),
                /*#__PURE__*/ _jsx(CheckoutWizardReadyStep, {
                    appProps: _object_spread({}, appContainerProps),
                    statusChange: stepListener,
                    usePaymentSelector: true
                }),
                isAddEditVisible && /*#__PURE__*/ _jsxs(AddEditView, {
                    context: context,
                    dismiss: dismissAddEditHandler,
                    children: [
                        checkoutWizardStep === StatusChangeSource.EditProfile && /*#__PURE__*/ _jsx(CheckoutWizardProfile, {
                            "data-bi-id": pbTelemetry.EditProfile,
                            "data-bi-name": pbTelemetry.EditProfileName,
                            appProps: _object_spread({}, appContainerProps),
                            statusChange: stepListener
                        }),
                        checkoutWizardStep === StatusChangeSource.AddProfile && /*#__PURE__*/ _jsx(CheckoutWizardAddProfile, {
                            "data-bi-id": pbTelemetry.AddProfile,
                            "data-bi-name": pbTelemetry.AddProfileName,
                            appProps: _object_spread({}, appContainerProps),
                            statusChange: stepListener
                        }),
                        checkoutWizardStep === StatusChangeSource.AddPayment && /*#__PURE__*/ _jsx(CheckoutWizardPayment, {
                            "data-bi-id": pbTelemetry.AddPayment,
                            "data-bi-name": pbTelemetry.AddPaymentName,
                            appProps: _object_spread({}, appContainerProps),
                            useNonDPPayment: true,
                            statusChange: stepListener
                        }),
                        checkoutWizardStep === StatusChangeSource.AddBillingProfile && /*#__PURE__*/ _jsx(CheckoutWizardBillingProfile, {
                            "data-bi-id": pbTelemetry.AddBillingProfile,
                            "data-bi-name": pbTelemetry.AddBillingProfileName,
                            appProps: _object_spread({}, appContainerProps),
                            isAddNew: true,
                            statusChange: stepListener
                        }),
                        checkoutWizardStep === StatusChangeSource.EditBillingProfile && /*#__PURE__*/ _jsx(CheckoutWizardBillingProfile, {
                            "data-bi-id": pbTelemetry.EditBillingProfile,
                            "data-bi-name": pbTelemetry.EditBillingProfileName,
                            appProps: _object_spread({}, appContainerProps),
                            statusChange: stepListener
                        })
                    ]
                }),
                hasFreeTrial && FreeTrialInfoText(context),
                /*#__PURE__*/ _jsx("div", {
                    className: contentStyles.legalTermsContainer,
                    children: /*#__PURE__*/ _jsx(DisclaimerComponent, {
                        "data-bi-id": pbTelemetry.PurchaseBlendsDisclaimerComponent,
                        "data-bi-name": pbTelemetry.PurchaseBlendsDisclaimerComponentName,
                        consentOption: getConsentState(billingCountry.toLowerCase()),
                        isCountryExcluded: isContactInfoHiddenInDisclaimer(getConsentState(billingCountry.toLowerCase())),
                        hideContactCheckbox: !(featureFlags.showConsent === 'true'),
                        termsOfUseUrl: (app === null || app === void 0 ? void 0 : app.licenseTermsUrl) || '',
                        privacyPolicyUrl: app === null || app === void 0 ? void 0 : (_app_detailInformation = app.detailInformation) === null || _app_detailInformation === void 0 ? void 0 : _app_detailInformation.PrivacyPolicyUrl
                    })
                })
            ]
        })
    });
};
export const PurchaseBlendsCheckoutWithRouter = PurchaseBlendsCheckout;
